<script>
    /*
    	ServiceFieldsGroup5Coverage.svelte

        Coverage - 5 fields

        Expandable/Collapsible and contains a predetermined set of DataFields
    */

    import { onMount } from 'svelte';
    import { COVER_AREAS, COVER_COUNTIES, COVER_POSTALS, COVER_GRAN, LOC_PRECISION } from '../../common/constants.js';
    import { shallowArraysEqual } from '../../common/utils.js';

    // new 09/01 - for populating API-aware fields
	import { fieldPresetsStore } from '../../stores/FieldPresetsStore.js';
	// import { fetchAllFieldsPresets, fetchSingleFieldPresets } from '../../stores/FieldPresetsStore.js';

    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import DataSelectField from '../data-fields/DataSelectField.svelte';
    import ApiArrayField from '../data-fields/ApiArrayField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    // SMUI components

    // const FIELDS = [ COVER_AREAS, COVER_COUNTIES, COVER_POSTALS, COVER_GRAN, LOC_PRECISION ];
    const GROUP_TITLE = 'Coverage';

    export let store;                   // store is a Service store - not just data!
    export let leftService;
    export let rightService;
    export let onCopyValue;
    export let isEditable;
    export let isOpen;
    export let showDiffs;               // bypass the strike-through and highlighting

    $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
        // console.log('ServiceFieldsGroup4 onMount');
    })

        
    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }

    // TODO: could move these to common area
    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

    const isArrayFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return !shallowArraysEqual(leftService[propName], rightService[propName]);
    }

</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />
    
    {#if apiData && isExpanded}
        <div class="fields-area">

            <!-- left and right blocks in a fluid row -->
            <div class="flex-row ai-start fluid">

                <div class="flex-block w-49">
                    <DataSelectField
                        bind:value={apiData[COVER_GRAN]}
                        choices={$fieldPresetsStore[COVER_GRAN]}
                        propName={COVER_GRAN}
                        label={'Granularity'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(COVER_GRAN)}
                        isNewDiff={isArrayFieldDiff(COVER_GRAN)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                    
                    <!-- 09/02 - make these always read only -->
                    <DataTextField
                        bind:value={apiData[COVER_COUNTIES]}
                        propName={COVER_COUNTIES}
                        label={'Counties'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(COVER_COUNTIES)}
                        isNewDiff={isFieldDiff(COVER_COUNTIES)}
                        onCopyValue={null}
                        tooltip={''}
                        showDiffs={false}
                    />

                    <!-- 09/02 - make these always read only -->
                    <DataTextField
                        bind:value={apiData[COVER_POSTALS]}
                        propName={COVER_POSTALS}
                        label={'ZIP Codes'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(COVER_POSTALS)}
                        isNewDiff={isFieldDiff(COVER_POSTALS)}
                        onCopyValue={null}
                        tooltip={''}
                        showDiffs={false}
                    />
                </div>

                <div class="flex-block w-49">
                    <!-- now using a ApiArrayField -->
                    <ApiArrayField
                        bind:value={apiData[COVER_AREAS]}
                        choices={null}
                        {store}
                        propName={COVER_AREAS}
                        label={'Coverage Areas'}
                        isEditable={isEditable}
                        isOrigDiff={isArrayFieldDiff(COVER_AREAS)}
                        isNewDiff={isArrayFieldDiff(COVER_AREAS)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                        isUserInput={true}
                        isUserSelect={false}
                    />

                    <DataSelectField
                        bind:value={apiData[LOC_PRECISION]}
                        choices={$fieldPresetsStore[LOC_PRECISION]}
                        propName={LOC_PRECISION}
                        label={'Loc Precision'}
                        isEditable={isEditable}
                        isOrigDiff={isFieldDiff(LOC_PRECISION)}
                        isNewDiff={isFieldDiff(LOC_PRECISION)}
                        onCopyValue={onCopyValue}
                        tooltip={''}
                        {showDiffs}
                    />
                </div>
            </div>      <!-- end flex-row -->
        </div>      <!-- end fields-area -->
    {/if}
</div>
